import type { ChecklistProblems } from '@/lib/checklist';

/**
 * The row-level problems of a rejected checklist upload (422 `invalid_checklist`)
 * as a readable Sheet / Row / Column / Message table, so the user can fix the
 * workbook and re-upload. The server lists at most 20; the rest are a "+N more".
 */
export function ChecklistProblemsTable({ problems, more }: ChecklistProblems) {
  return (
    <div className="space-y-2" role="alert">
      <p className="text-sm font-medium text-destructive">
        This checklist file can&apos;t be used yet — fix the rows below and upload it again.
      </p>
      <div className="max-h-64 overflow-auto rounded-md border">
        <table className="w-full text-xs">
          <thead className="sticky top-0 bg-muted">
            <tr className="text-left text-muted-foreground">
              <th className="px-2 py-1.5 font-medium">Sheet</th>
              <th className="px-2 py-1.5 font-medium">Row</th>
              <th className="px-2 py-1.5 font-medium">Column</th>
              <th className="px-2 py-1.5 font-medium">Problem</th>
            </tr>
          </thead>
          <tbody>
            {problems.map((p, i) => (
              <tr key={i} className="border-t align-top">
                <td className="px-2 py-1.5">{p.sheet ?? '—'}</td>
                <td className="px-2 py-1.5 tabular-nums">{p.row > 0 ? p.row : '—'}</td>
                <td className="px-2 py-1.5">{p.column ?? '—'}</td>
                <td className="px-2 py-1.5">{p.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {more > 0 ? (
        <p className="text-xs text-muted-foreground">
          +{more} more {more === 1 ? 'problem' : 'problems'} not shown.
        </p>
      ) : null}
    </div>
  );
}
